/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
import { __assign } from "tslib";
import { CloudErrorMapper, BaseResourceMapper } from "@azure/ms-rest-azure-js";
export var CloudError = CloudErrorMapper;
export var BaseResource = BaseResourceMapper;
export var CoreInfo = {
  serializedName: "CoreInfo",
  type: {
    name: "Composite",
    className: "CoreInfo",
    modelProperties: {
      standard: {
        required: true,
        serializedName: "standard",
        type: {
          name: "Number"
        }
      },
      gpu: {
        required: true,
        serializedName: "gpu",
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var CoreUsage = {
  serializedName: "CoreUsage",
  type: {
    name: "Composite",
    className: "CoreUsage",
    modelProperties: {
      used: {
        required: true,
        serializedName: "used",
        type: {
          name: "Composite",
          className: "CoreInfo"
        }
      },
      alloted: {
        required: true,
        serializedName: "alloted",
        type: {
          name: "Composite",
          className: "CoreInfo"
        }
      }
    }
  }
};
export var Resource = {
  serializedName: "Resource",
  type: {
    name: "Composite",
    className: "Resource",
    modelProperties: {
      id: {
        readOnly: true,
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      name: {
        readOnly: true,
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      type: {
        readOnly: true,
        serializedName: "type",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var TrackedResource = {
  serializedName: "TrackedResource",
  type: {
    name: "Composite",
    className: "TrackedResource",
    modelProperties: __assign(__assign({}, Resource.type.modelProperties), {
      tags: {
        serializedName: "tags",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "String"
            }
          }
        }
      },
      location: {
        required: true,
        serializedName: "location",
        type: {
          name: "String"
        }
      }
    })
  }
};
export var Lab = {
  serializedName: "Lab",
  type: {
    name: "Composite",
    className: "Lab",
    modelProperties: __assign(__assign({}, TrackedResource.type.modelProperties), {
      systemData: {
        readOnly: true,
        serializedName: "systemData",
        type: {
          name: "Composite",
          className: "SystemData"
        }
      },
      autoShutdownProfile: {
        serializedName: "properties.autoShutdownProfile",
        type: {
          name: "Composite",
          className: "AutoShutdownProfile"
        }
      },
      connectionProfile: {
        serializedName: "properties.connectionProfile",
        type: {
          name: "Composite",
          className: "ConnectionProfile"
        }
      },
      virtualMachineProfile: {
        serializedName: "properties.virtualMachineProfile",
        type: {
          name: "Composite",
          className: "VirtualMachineProfile"
        }
      },
      securityProfile: {
        serializedName: "properties.securityProfile",
        type: {
          name: "Composite",
          className: "SecurityProfile"
        }
      },
      rosterProfile: {
        serializedName: "properties.rosterProfile",
        type: {
          name: "Composite",
          className: "RosterProfile"
        }
      },
      labPlanId: {
        serializedName: "properties.labPlanId",
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "properties.title",
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "properties.description",
        type: {
          name: "String"
        }
      },
      provisioningState: {
        readOnly: true,
        serializedName: "properties.provisioningState",
        type: {
          name: "Enum",
          allowedValues: ["Creating", "Updating", "Deleting", "Succeeded", "Failed", "Locked"]
        }
      },
      networkProfile: {
        serializedName: "properties.networkProfile",
        type: {
          name: "Composite",
          className: "LabNetworkProfile"
        }
      },
      state: {
        readOnly: true,
        serializedName: "properties.state",
        type: {
          name: "Enum",
          allowedValues: ["Draft", "Publishing", "Scaling", "Syncing", "Published"]
        }
      }
    })
  }
};
export var CreateLab = {
  serializedName: "CreateLab",
  type: {
    name: "Composite",
    className: "CreateLab",
    modelProperties: __assign({}, Lab.type.modelProperties)
  }
};
export var PublishLab = {
  serializedName: "PublishLab",
  type: {
    name: "Composite",
    className: "PublishLab",
    modelProperties: {
      capacity: {
        serializedName: "capacity",
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var ResourceOperationError = {
  serializedName: "ResourceOperationError",
  type: {
    name: "Composite",
    className: "ResourceOperationError",
    modelProperties: {
      timestamp: {
        serializedName: "timestamp",
        type: {
          name: "DateTime"
        }
      },
      code: {
        serializedName: "code",
        type: {
          name: "String"
        }
      },
      message: {
        serializedName: "message",
        type: {
          name: "String"
        }
      },
      action: {
        serializedName: "action",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var LocationPriceAndAvailabilityData = {
  serializedName: "LocationPriceAndAvailabilityData",
  type: {
    name: "Composite",
    className: "LocationPriceAndAvailabilityData",
    modelProperties: {
      name: {
        required: true,
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      availability: {
        required: true,
        serializedName: "availability",
        type: {
          name: "Enum",
          allowedValues: ["Available", "Unavailable", "Deprecated", "Disabled"]
        }
      },
      displayName: {
        required: true,
        serializedName: "displayName",
        type: {
          name: "String"
        }
      },
      price: {
        required: true,
        serializedName: "price",
        type: {
          name: "Number"
        }
      },
      currencyCode: {
        required: true,
        serializedName: "currencyCode",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var SizePriceAndAvailabilityData = {
  serializedName: "SizePriceAndAvailabilityData",
  type: {
    name: "Composite",
    className: "SizePriceAndAvailabilityData",
    modelProperties: {
      name: {
        required: true,
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      availability: {
        required: true,
        serializedName: "availability",
        type: {
          name: "Enum",
          allowedValues: ["Available", "Unavailable", "Deprecated", "Disabled"]
        }
      },
      displayName: {
        required: true,
        serializedName: "displayName",
        type: {
          name: "String"
        }
      },
      description: {
        required: true,
        serializedName: "description",
        type: {
          name: "String"
        }
      },
      ordinal: {
        required: true,
        serializedName: "ordinal",
        type: {
          name: "Number"
        }
      },
      memoryInGB: {
        required: true,
        serializedName: "memoryInGB",
        type: {
          name: "Number"
        }
      },
      cores: {
        required: true,
        serializedName: "cores",
        type: {
          name: "Number"
        }
      },
      discreteGpu: {
        required: true,
        serializedName: "discreteGpu",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      },
      locations: {
        required: true,
        serializedName: "locations",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Composite",
              className: "LocationPriceAndAvailabilityData"
            }
          }
        }
      }
    }
  }
};
export var OSPriceAndAvailabilityData = {
  serializedName: "OSPriceAndAvailabilityData",
  type: {
    name: "Composite",
    className: "OSPriceAndAvailabilityData",
    modelProperties: {
      name: {
        required: true,
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      availability: {
        required: true,
        serializedName: "availability",
        type: {
          name: "Enum",
          allowedValues: ["Available", "Unavailable", "Deprecated", "Disabled"]
        }
      },
      sizes: {
        required: true,
        serializedName: "sizes",
        type: {
          name: "Dictionary",
          value: {
            type: {
              name: "Composite",
              className: "SizePriceAndAvailabilityData"
            }
          }
        }
      }
    }
  }
};
export var VirtualMachinePriceAndAvailabilityData = {
  serializedName: "VirtualMachinePriceAndAvailabilityData",
  type: {
    name: "Composite",
    className: "VirtualMachinePriceAndAvailabilityData",
    modelProperties: {
      windows: {
        required: true,
        serializedName: "Windows",
        type: {
          name: "Composite",
          className: "OSPriceAndAvailabilityData"
        }
      },
      linux: {
        required: true,
        serializedName: "Linux",
        type: {
          name: "Composite",
          className: "OSPriceAndAvailabilityData"
        }
      }
    }
  }
};
export var SupportInfo = {
  serializedName: "SupportInfo",
  type: {
    name: "Composite",
    className: "SupportInfo",
    modelProperties: {
      url: {
        serializedName: "url",
        type: {
          name: "String"
        }
      },
      email: {
        serializedName: "email",
        type: {
          name: "String"
        }
      },
      phone: {
        serializedName: "phone",
        type: {
          name: "String"
        }
      },
      instructions: {
        serializedName: "instructions",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var VirtualMachine = {
  serializedName: "VirtualMachine",
  type: {
    name: "Composite",
    className: "VirtualMachine",
    modelProperties: {
      state: {
        readOnly: true,
        serializedName: "state",
        type: {
          name: "Enum",
          allowedValues: ["Creating", "Updating", "Deleting", "Moving", "Stopped", "Starting", "Running", "Stopping", "ResettingPassword", "Reimaging", "Redeploying"]
        }
      },
      title: {
        readOnly: true,
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      description: {
        readOnly: true,
        serializedName: "description",
        type: {
          name: "String"
        }
      },
      location: {
        readOnly: true,
        serializedName: "location",
        type: {
          name: "String"
        }
      },
      subscriptionId: {
        readOnly: true,
        serializedName: "subscriptionId",
        type: {
          name: "String"
        }
      },
      id: {
        required: true,
        readOnly: true,
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      privateIpAddress: {
        readOnly: true,
        serializedName: "privateIpAddress",
        type: {
          name: "String"
        }
      },
      sshAuthority: {
        readOnly: true,
        serializedName: "sshAuthority",
        type: {
          name: "String"
        }
      },
      sshInBrowserUrl: {
        readOnly: true,
        serializedName: "sshInBrowserUrl",
        type: {
          name: "String"
        }
      },
      rdpAuthority: {
        readOnly: true,
        serializedName: "rdpAuthority",
        type: {
          name: "String"
        }
      },
      rdpInBrowserUrl: {
        readOnly: true,
        serializedName: "rdpInBrowserUrl",
        type: {
          name: "String"
        }
      },
      username: {
        readOnly: true,
        serializedName: "username",
        type: {
          name: "String"
        }
      },
      useSharedPassword: {
        readOnly: true,
        serializedName: "useSharedPassword",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      },
      quotaUsed: {
        readOnly: true,
        serializedName: "quotaUsed",
        type: {
          name: "TimeSpan"
        }
      },
      totalQuota: {
        readOnly: true,
        serializedName: "totalQuota",
        type: {
          name: "TimeSpan"
        }
      },
      scheduleEndTime: {
        readOnly: true,
        serializedName: "scheduleEndTime",
        type: {
          name: "DateTime"
        }
      },
      lastStarted: {
        readOnly: true,
        serializedName: "lastStarted",
        type: {
          name: "DateTime"
        }
      },
      lastStopped: {
        readOnly: true,
        serializedName: "lastStopped",
        type: {
          name: "DateTime"
        }
      },
      lastPasswordReset: {
        readOnly: true,
        serializedName: "lastPasswordReset",
        type: {
          name: "DateTime"
        }
      },
      osType: {
        readOnly: true,
        serializedName: "osType",
        type: {
          name: "Enum",
          allowedValues: ["Windows", "Linux"]
        }
      },
      supportInfo: {
        readOnly: true,
        serializedName: "supportInfo",
        type: {
          name: "Composite",
          className: "SupportInfo"
        }
      },
      resourceOperationError: {
        readOnly: true,
        serializedName: "resourceOperationError",
        type: {
          name: "Composite",
          className: "ResourceOperationError"
        }
      }
    }
  }
};
export var ResetPasswordBody = {
  serializedName: "ResetPasswordBody",
  type: {
    name: "Composite",
    className: "ResetPasswordBody",
    modelProperties: {
      username: {
        required: true,
        serializedName: "username",
        type: {
          name: "String"
        }
      },
      password: {
        required: true,
        serializedName: "password",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var LabServicesPrice = {
  serializedName: "LabServicesPrice",
  type: {
    name: "Composite",
    className: "LabServicesPrice",
    modelProperties: {
      availability: {
        serializedName: "availability",
        type: {
          name: "Enum",
          allowedValues: ["Available", "Unavailable", "Deprecated", "Disabled"]
        }
      },
      currencyCode: {
        readOnly: true,
        serializedName: "currencyCode",
        type: {
          name: "String"
        }
      },
      location: {
        readOnly: true,
        serializedName: "location",
        type: {
          name: "String"
        }
      },
      meterId: {
        readOnly: true,
        serializedName: "meterId",
        type: {
          name: "String"
        }
      },
      resourceType: {
        readOnly: true,
        serializedName: "resourceType",
        type: {
          name: "String"
        }
      },
      value: {
        readOnly: true,
        serializedName: "value",
        type: {
          name: "Number"
        }
      },
      unit: {
        readOnly: true,
        serializedName: "unit",
        type: {
          name: "String"
        }
      },
      skuName: {
        readOnly: true,
        serializedName: "skuName",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var ErrorAdditionalInfo = {
  serializedName: "ErrorAdditionalInfo",
  type: {
    name: "Composite",
    className: "ErrorAdditionalInfo",
    modelProperties: {
      type: {
        readOnly: true,
        serializedName: "type",
        type: {
          name: "String"
        }
      },
      info: {
        readOnly: true,
        serializedName: "info",
        type: {
          name: "Object"
        }
      }
    }
  }
};
export var ErrorDetail = {
  serializedName: "ErrorDetail",
  type: {
    name: "Composite",
    className: "ErrorDetail",
    modelProperties: {
      code: {
        readOnly: true,
        serializedName: "code",
        type: {
          name: "String"
        }
      },
      message: {
        readOnly: true,
        serializedName: "message",
        type: {
          name: "String"
        }
      },
      target: {
        readOnly: true,
        serializedName: "target",
        type: {
          name: "String"
        }
      },
      details: {
        readOnly: true,
        serializedName: "details",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ErrorDetail"
            }
          }
        }
      },
      additionalInfo: {
        readOnly: true,
        serializedName: "additionalInfo",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "ErrorAdditionalInfo"
            }
          }
        }
      }
    }
  }
};
export var OperationResult = {
  serializedName: "OperationResult",
  type: {
    name: "Composite",
    className: "OperationResult",
    modelProperties: {
      id: {
        readOnly: true,
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      name: {
        readOnly: true,
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      status: {
        required: true,
        serializedName: "status",
        type: {
          name: "Enum",
          allowedValues: ["NotStarted", "InProgress", "Succeeded", "Failed", "Canceled"]
        }
      },
      startTime: {
        serializedName: "startTime",
        type: {
          name: "DateTime"
        }
      },
      endTime: {
        serializedName: "endTime",
        type: {
          name: "DateTime"
        }
      },
      percentComplete: {
        serializedName: "percentComplete",
        type: {
          name: "Number"
        }
      },
      error: {
        serializedName: "error",
        type: {
          name: "Composite",
          className: "ErrorDetail"
        }
      }
    }
  }
};
export var AutoShutdownProfile = {
  serializedName: "AutoShutdownProfile",
  type: {
    name: "Composite",
    className: "AutoShutdownProfile",
    modelProperties: {
      shutdownOnDisconnect: {
        serializedName: "shutdownOnDisconnect",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      },
      shutdownWhenNotConnected: {
        serializedName: "shutdownWhenNotConnected",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      },
      shutdownOnIdle: {
        serializedName: "shutdownOnIdle",
        type: {
          name: "Enum",
          allowedValues: ["None", "UserAbsence", "LowUsage"]
        }
      },
      disconnectDelay: {
        serializedName: "disconnectDelay",
        type: {
          name: "TimeSpan"
        }
      },
      noConnectDelay: {
        serializedName: "noConnectDelay",
        type: {
          name: "TimeSpan"
        }
      },
      idleDelay: {
        serializedName: "idleDelay",
        type: {
          name: "TimeSpan"
        }
      }
    }
  }
};
export var ConnectionProfile = {
  serializedName: "ConnectionProfile",
  type: {
    name: "Composite",
    className: "ConnectionProfile",
    modelProperties: {
      webSshAccess: {
        serializedName: "webSshAccess",
        type: {
          name: "Enum",
          allowedValues: ["Public", "Private", "None"]
        }
      },
      webRdpAccess: {
        serializedName: "webRdpAccess",
        type: {
          name: "Enum",
          allowedValues: ["Public", "Private", "None"]
        }
      },
      clientSshAccess: {
        serializedName: "clientSshAccess",
        type: {
          name: "Enum",
          allowedValues: ["Public", "Private", "None"]
        }
      },
      clientRdpAccess: {
        serializedName: "clientRdpAccess",
        type: {
          name: "Enum",
          allowedValues: ["Public", "Private", "None"]
        }
      }
    }
  }
};
export var SystemData = {
  serializedName: "systemData",
  type: {
    name: "Composite",
    className: "SystemData",
    modelProperties: {
      createdBy: {
        serializedName: "createdBy",
        type: {
          name: "String"
        }
      },
      createdByType: {
        serializedName: "createdByType",
        type: {
          name: "String"
        }
      },
      createdAt: {
        serializedName: "createdAt",
        type: {
          name: "DateTime"
        }
      },
      lastModifiedBy: {
        serializedName: "lastModifiedBy",
        type: {
          name: "String"
        }
      },
      lastModifiedByType: {
        serializedName: "lastModifiedByType",
        type: {
          name: "String"
        }
      },
      lastModifiedAt: {
        serializedName: "lastModifiedAt",
        type: {
          name: "DateTime"
        }
      }
    }
  }
};
export var LabNetworkProfile = {
  serializedName: "LabNetworkProfile",
  type: {
    name: "Composite",
    className: "LabNetworkProfile",
    modelProperties: {
      subnetId: {
        serializedName: "subnetId",
        type: {
          name: "String"
        }
      },
      loadBalancerId: {
        serializedName: "loadBalancerId",
        type: {
          name: "String"
        }
      },
      publicIpId: {
        serializedName: "publicIpId",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var ImageReference = {
  serializedName: "ImageReference",
  type: {
    name: "Composite",
    className: "ImageReference",
    modelProperties: {
      id: {
        serializedName: "id",
        type: {
          name: "String"
        }
      },
      offer: {
        serializedName: "offer",
        type: {
          name: "String"
        }
      },
      publisher: {
        serializedName: "publisher",
        type: {
          name: "String"
        }
      },
      sku: {
        serializedName: "sku",
        type: {
          name: "String"
        }
      },
      version: {
        serializedName: "version",
        type: {
          name: "String"
        }
      },
      exactVersion: {
        readOnly: true,
        serializedName: "exactVersion",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var Sku = {
  serializedName: "Sku",
  type: {
    name: "Composite",
    className: "Sku",
    modelProperties: {
      name: {
        required: true,
        serializedName: "name",
        type: {
          name: "String"
        }
      },
      tier: {
        serializedName: "tier",
        type: {
          name: "Enum",
          allowedValues: ["Free", "Basic", "Standard", "Premium"]
        }
      },
      size: {
        serializedName: "size",
        type: {
          name: "String"
        }
      },
      family: {
        serializedName: "family",
        type: {
          name: "String"
        }
      },
      capacity: {
        serializedName: "capacity",
        type: {
          name: "Number"
        }
      }
    }
  }
};
export var VirtualMachineAdditionalCapabilities = {
  serializedName: "VirtualMachineAdditionalCapabilities",
  type: {
    name: "Composite",
    className: "VirtualMachineAdditionalCapabilities",
    modelProperties: {
      installGpuDrivers: {
        serializedName: "installGpuDrivers",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      }
    }
  }
};
export var Credentials = {
  serializedName: "Credentials",
  type: {
    name: "Composite",
    className: "Credentials",
    modelProperties: {
      username: {
        required: true,
        serializedName: "username",
        type: {
          name: "String"
        }
      },
      password: {
        serializedName: "password",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var VirtualMachineProfile = {
  serializedName: "VirtualMachineProfile",
  type: {
    name: "Composite",
    className: "VirtualMachineProfile",
    modelProperties: {
      createOption: {
        required: true,
        serializedName: "createOption",
        type: {
          name: "Enum",
          allowedValues: ["Image", "TemplateVM"]
        }
      },
      imageReference: {
        required: true,
        serializedName: "imageReference",
        type: {
          name: "Composite",
          className: "ImageReference"
        }
      },
      osType: {
        readOnly: true,
        serializedName: "osType",
        type: {
          name: "Enum",
          allowedValues: ["Windows", "Linux"]
        }
      },
      sku: {
        required: true,
        serializedName: "sku",
        type: {
          name: "Composite",
          className: "Sku"
        }
      },
      additionalCapabilities: {
        serializedName: "additionalCapabilities",
        type: {
          name: "Composite",
          className: "VirtualMachineAdditionalCapabilities"
        }
      },
      usageQuota: {
        required: true,
        serializedName: "usageQuota",
        type: {
          name: "TimeSpan"
        }
      },
      useSharedPassword: {
        serializedName: "useSharedPassword",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      },
      adminUser: {
        required: true,
        serializedName: "adminUser",
        type: {
          name: "Composite",
          className: "Credentials"
        }
      },
      nonAdminUser: {
        serializedName: "nonAdminUser",
        type: {
          name: "Composite",
          className: "Credentials"
        }
      }
    }
  }
};
export var SecurityProfile = {
  serializedName: "SecurityProfile",
  type: {
    name: "Composite",
    className: "SecurityProfile",
    modelProperties: {
      registrationCode: {
        readOnly: true,
        serializedName: "registrationCode",
        type: {
          name: "String"
        }
      },
      openAccess: {
        serializedName: "openAccess",
        type: {
          name: "Enum",
          allowedValues: ["Enabled", "Disabled"]
        }
      }
    }
  }
};
export var RosterProfile = {
  serializedName: "RosterProfile",
  type: {
    name: "Composite",
    className: "RosterProfile",
    modelProperties: {
      activeDirectoryGroupId: {
        serializedName: "activeDirectoryGroupId",
        type: {
          name: "String"
        }
      },
      ltiContextId: {
        serializedName: "ltiContextId",
        type: {
          name: "String"
        }
      },
      lmsInstance: {
        serializedName: "lmsInstance",
        type: {
          name: "String"
        }
      },
      ltiClientId: {
        serializedName: "ltiClientId",
        type: {
          name: "String"
        }
      },
      ltiRosterEndpoint: {
        serializedName: "ltiRosterEndpoint",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var LabUpdateProperties = {
  serializedName: "LabUpdateProperties",
  type: {
    name: "Composite",
    className: "LabUpdateProperties",
    modelProperties: {
      autoShutdownProfile: {
        serializedName: "autoShutdownProfile",
        type: {
          name: "Composite",
          className: "AutoShutdownProfile"
        }
      },
      connectionProfile: {
        serializedName: "connectionProfile",
        type: {
          name: "Composite",
          className: "ConnectionProfile"
        }
      },
      virtualMachineProfile: {
        serializedName: "virtualMachineProfile",
        type: {
          name: "Composite",
          className: "VirtualMachineProfile"
        }
      },
      securityProfile: {
        serializedName: "securityProfile",
        type: {
          name: "Composite",
          className: "SecurityProfile"
        }
      },
      rosterProfile: {
        serializedName: "rosterProfile",
        type: {
          name: "Composite",
          className: "RosterProfile"
        }
      },
      labPlanId: {
        serializedName: "labPlanId",
        type: {
          name: "String"
        }
      },
      title: {
        serializedName: "title",
        type: {
          name: "String"
        }
      },
      description: {
        serializedName: "description",
        type: {
          name: "String"
        }
      }
    }
  }
};
export var PagedLabServicesPrices = {
  serializedName: "PagedLabServicesPrices",
  type: {
    name: "Composite",
    className: "PagedLabServicesPrices",
    modelProperties: {
      value: {
        readOnly: true,
        serializedName: "",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "LabServicesPrice"
            }
          }
        }
      },
      nextLink: {
        readOnly: true,
        serializedName: "nextLink",
        type: {
          name: "String"
        }
      }
    }
  }
};